import React from 'react';
import { useOfflineContext } from 'contexts/OfflineContext/OfflineContext';
import { useNetworkStatus } from 'hooks/useNetworkStatus';
import { OfflineWithReconnectAlert } from './OfflineWithReconnectAlert';
import { OfflineAlert } from './OfflineAlert';

export const OfflineWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { varient } = useOfflineContext();

  // Only one instance of useNetworkStatus in the app.
  // Calling this at multiple places will cause multiple event listeners to be added.
  // Also might create race conditions with the online and alert status.
  const { isOnline, showOfflineAlert, dismissAlert } = useNetworkStatus();

  if (varient === 'assessment-offline-alert') {
    return (
      <>
        {children}
        <OfflineWithReconnectAlert
          isOnline={isOnline}
          showOfflineAlert={showOfflineAlert}
          dismissAlert={dismissAlert}
        />
      </>
    );
  }

  return (
    <>
      {children}
      <OfflineAlert showOfflineAlert={showOfflineAlert} dismissAlert={dismissAlert} />
    </>
  );
};
